import React from 'react';

import {Home, About, Counter, Services, Team, Testimonials, Blogs, Partners, Booking, Banner, CarCategories, HomeCars, PortfolioSection} from '../../sections'; 


 
const HomePage = () => { 

  return ( 
    <div className='homepage'>
      <Home /> {/* Home section */}
      <Booking /> {/* Home Booking Form */}
      <About /> {/* About section */}
      <Services /> {/* Services section */}
      <Counter /> {/* Counter section */}
      <CarCategories /> {/* Top 5 Car Categories Section */}
      <PortfolioSection /> {/* Portfolio section */}
      <Banner /> {/* Banner section */}
      <HomeCars /> {/* Featured Slider section */}
      <Team /> {/* Team section */}
      <Testimonials /> {/* Testimonials Slider */}
      <Blogs /> {/* Recent Blogs section */}
      <Partners /> {/* Partners Slider section */}
    </div>
  )
}

export default HomePage;